import React from 'react';
import './Materialcharact.css';

const cardData = [
  {
    title: 'Material Characteristics',
    description: 'Thin-wall products such as injection-molded PP snack boxes require high fluidity; and have sufficient strength, hardness and a relatively simple molecular weight distribution.',
  },
  {
    title: 'Injection Molding Process',
    description: 'The material temperature should not be too high, or else products that exceed 300 degrees will become brittle;The pressure should not be too large, it may caused deformed by more than 120 hectopascals.',
  },
 
];

const Materialcharact = () => {
  return (
    <div  className="container">
         <div className="highsion">
      {cardData.map((card, index) => (
        <div className="highsion-card" key={index}>
          <h1>{card.title}</h1>
          <p>{card.description}</p>
        </div>
      ))}
    </div>
    </div>
   
  );
};

export default Materialcharact;
